import React from 'react';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';

import StageFormContentGroup from '../StageFormContentGroup/StageFormContentGroup';
import GroupCollapsibleContainer from '../GroupCollapsibleContainer/GroupCollapsibleContainer';

const StageForm = ({ data, formData, setFormData, expandedGroups, setExpandedGroups }) => {
    const { isDesktop } = useResponsiveBreakpoints();
    const isEditable = !!isDesktop;

    const toggleExpand = (order) => {
        setExpandedGroups((prev) => ({
            ...prev,
            [order]: !prev[order],
        }));
    };

    return (
        <>
            {data.map((group) => {
                const { order, label, description } = group;

                const isExpanded = expandedGroups[order];

                const setGroupFormData = (cb) => {
                    setFormData((prevData) => ({
                        ...prevData,
                        [order]: typeof cb === 'function' ? cb(prevData[order]) : cb,
                    }));
                };

                return (
                    <GroupCollapsibleContainer
                        key={order}
                        title={label}
                        description={description}
                        isExpanded={isExpanded}
                        toggleExpand={() => toggleExpand(group.order)}
                    >
                        <StageFormContentGroup
                            group={group}
                            groupFormData={formData[order]}
                            setGroupFormData={setGroupFormData}
                            isEditable={isEditable}
                        />
                    </GroupCollapsibleContainer>
                );
            })}
        </>
    );
};

export default StageForm;
